import { SECTOR_WAVE_SPAN } from "./sectors"

export const getWaveAnnouncementMessage = (wave: number): string => {
  if (wave === 1) {
    return "Stay near mid-screen, collect coins, and hit 5 bumpers to overdrive."
  }

  if (wave % SECTOR_WAVE_SPAN === 0) {
    return "Boss pressure spike. Stay mid-screen and use bumpers for overdrives."
  }

  if ((wave + 1) % SECTOR_WAVE_SPAN === 0) {
    return "Boss wave next. Stock up on bumper charges and save your coins for the shop."
  }

  if (wave >= 15) {
    return "Endgame pace. Survival is everything now."
  }

  if (wave >= 10) {
    return "The swarm thickens here. Use bumpers for cover and do not drift low."
  }

  return "Glowing bumpers give bonus points and power-ups. Seek them out!"
}
